<div class="controls-container">
    <div class="controls-header">Switch</div>

    <div class="controls-sub-header">Switch Default</div>

    <pm-switch></pm-switch>

    <div class="controls-sub-header">Switch Disabled</div>
    
    <pm-switch IsDisabled="true"></pm-switch>

    <div class="controls-sub-header">Switch Theme 1</div>

    <pm-switch SwitchTheme="theme-1"></pm-switch>

    <div class="controls-sub-header">Switch Theme 2</div>

    <pm-switch SwitchTheme="theme-2"></pm-switch>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/switch/switch.html